<div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="20px grid" *ngIf="displayError">
    <mat-card-content fxFlex="" fxFlexFill>
        <mat-error>{{displayErrorMessage}}</mat-error>
    </mat-card-content>
</div>